import { combineReducers } from "redux";

import types from "actions/actionTypes";

const visibilityReducer = (state = false, action) => {
  if (action.type === types.TOGGLE_COLUMN_PICKER) {
    return !state;
  }
  return state;
};

const columnStateReducer = (
  state = {
    "Claim #": { active: true, visible: true },
    "Insured Name": { active: true, visible: true },
    Vehicle: { active: true, visible: true },
    State: { active: true, visible: true },
    "Loss Date": { active: true, visible: true },
    "Creation Date": { active: true, visible: true },
    Status: { active: true, visible: true },
    Actions: { active: true, visible: false }
  },
  action
) => {
  if (action.type === types.SET_COLUMN_ACTIVE) {
    return {
      ...state,
      [action.payload.column]: {
        ...state[action.payload.column],
        active: action.payload.isActive
      }
    };
  }
  if (action.type === types.SET_COLUMN_VISIBLE) {
    return {
      ...state,
      [action.payload.column]: {
        ...state[action.payload.column],
        visible: action.payload.visible
      }
    };
  }
  return state;
};

const columnOrderReducer = (
  state = [
    "Claim #",
    "Insured Name",
    "Vehicle",
    "State",
    "Loss Date",
    "Creation Date",
    "Status",
    "Actions"
  ],
  action
) => {
  if (action.type === types.SET_COLUMN_ORDER) {
    const newState = [...state];
    const fromIndex = newState.indexOf(action.payload.column)
    const actionIndex = newState.indexOf("Actions");
    newState.splice(fromIndex, 1);
    const toIndex = (action.payload.workList === "In Progress" && action.payload.toIndex > actionIndex) ? action.payload.toIndex + 1 : action.payload.toIndex;
    newState.splice(toIndex, 0, action.payload.column);
    return newState;
  }
  return state;
};

const rootReducer = combineReducers({
  visibility: visibilityReducer,
  columnState: columnStateReducer,
  columnOrder: columnOrderReducer
});

export default rootReducer;
